let loadingGoogle = false;

const callbacks = [];

const loadJs = (url, cb) => {
  callbacks.push(cb);

  if (!loadingGoogle) {
    loadingGoogle = true;
    const scriptTag = document.createElement('script');
    scriptTag.src = url;

    scriptTag.onload = () => {
      loadingGoogle = false;
      callbacks.forEach((callback) => callback());
    };

    document.body.appendChild(scriptTag);
  }
};

export default loadJs;
